import React from 'react';
import { Eye, EyeOff, ChevronUp, ChevronDown, GripVertical } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

export const SECTION_LABELS = {
  checkin: 'Check-in & Check-out',
  wifi: 'Wi-Fi',
  rules: 'House Rules',
  essentials: 'Amenities & How-Tos',
  house_map: 'House Map / Where Things Are',
  gallery: 'Photo & Video Gallery',
  checkout: 'Checkout Checklist',
  contact: 'Contact Your Host',
};

export const sectionLabel = (key, gb) => SECTION_LABELS[key] || gb.custom_sections.find((c) => `custom-${c.id}` === key)?.title || 'Custom section';

export const SectionOrderCard = ({ gb, onChange }) => {
  const order = gb.section_order;
  const hidden = new Set(gb.hidden_sections);
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= order.length) return;
    const next = [...order];
    [next[i], next[j]] = [next[j], next[i]];
    onChange({ section_order: next });
  };
  const toggle = (key) => onChange({ hidden_sections: hidden.has(key) ? gb.hidden_sections.filter((k) => k !== key) : [...gb.hidden_sections, key] });

  return (
    <Card data-testid="gb-section-order-card">
      <CardHeader className="pb-3"><CardTitle className="text-base">Section order & visibility</CardTitle></CardHeader>
      <CardContent className="space-y-1.5">
        {order.map((key, i) => (
          <div key={key} data-testid={`gb-order-row-${key}`} className={`flex items-center gap-2 rounded-lg border px-2 py-1.5 text-sm ${hidden.has(key) ? 'bg-slate-100 text-slate-400 border-dashed' : 'bg-white text-slate-800'}`}>
            <GripVertical className="h-4 w-4 text-slate-300" />
            <span className="flex-1 truncate">{sectionLabel(key, gb)}</span>
            <button type="button" aria-label="Move up" data-testid={`gb-order-up-${key}`} onClick={() => move(i, -1)} disabled={i === 0} className="text-slate-400 hover:text-slate-900 disabled:opacity-30"><ChevronUp className="h-4 w-4" /></button>
            <button type="button" aria-label="Move down" data-testid={`gb-order-down-${key}`} onClick={() => move(i, 1)} disabled={i === order.length - 1} className="text-slate-400 hover:text-slate-900 disabled:opacity-30"><ChevronDown className="h-4 w-4" /></button>
            <button type="button" aria-label={hidden.has(key) ? 'Show section' : 'Hide section'} data-testid={`gb-order-toggle-${key}`} onClick={() => toggle(key)} className="text-slate-500 hover:text-slate-900">
              {hidden.has(key) ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        ))}
        <p className="text-xs text-slate-500 pt-1">Hidden sections stay saved but are not shown to guests.</p>
      </CardContent>
    </Card>
  );
};
